export type AuthPhase =
  | { kind: "starting" }
  | { kind: "hydrated"; userId: string | null }
  | { kind: "ready"; userId: string | null; error: string | null };

export type DevAuth = {
  observe(phase: AuthPhase): void;
  observeApiUser(id: string): void;
};

export const devAuth: DevAuth | null = null;
